import { Link } from '@onhandtech/onhand-toolkit'
import type { RouteKey } from 'contracts/config/routes'
import { useIntl } from 'react-intl'

import { getRoutePath } from '../../router/router.utils'

import * as CSS from './navigation-items.styles'

// Putting these here because we don't want to render all
// the routes, like SIGN_IN etc... Can move when we need
// more. Exporting for jest.
export const navItems: RouteKey[] = ['CODES', 'MISSIONS', 'QR_CODE', 'CONTENT', 'CREATE_ORG']

const NavigationItems = () => {
  const { formatMessage } = useIntl()

  return (
    <CSS.NavigationItems>
      {navItems.map((routeKey) => {
        const lowercaseRoute = routeKey.toLowerCase()
        return (
          <Link key={routeKey} to={getRoutePath(routeKey)} id={lowercaseRoute}>
            {formatMessage({ id: `navigation.link.${lowercaseRoute}` })}
          </Link>
        )
      })}
    </CSS.NavigationItems>
  )
}

export default NavigationItems
